import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/cd-ladder-calculator',
  component: () => import('../../routes/CdLadderCalculator.svelte'),
  card: {
    id: 'cd-ladder-calculator',
    title: 'CD Ladder Strategy',
    description: 'Build a CD ladder to earn competitive rates while maintaining liquidity. Spread your savings across CDs with staggered maturity dates.',
    icon: 'account_balance',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/cd-ladder-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'CD Ladder Calculator – Certificate of Deposit Ladder Strategy Builder',
    description: 'Free CD ladder calculator to build a staggered CD investment strategy. See how spreading savings across multiple CDs with different maturity dates maximizes returns while maintaining liquidity.',
  },
};

export default meta;
